// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1cuS2","topBottomGutter":"Layout_topBottomGutter__3xtv4"};